import {
  Card,
  Table,
  Button,
  Spin,
  Row,
  Col,
  Space,
  Tooltip,
  Dropdown,
  Menu,
  Input,
  Drawer,
  Divider,
  message,
  Modal,
  Tabs,
  Select,
  notification,
  Empty,
  Tag,
} from "antd"
import {
  AppstoreOutlined,
  CloseOutlined,
  CloudSyncOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  ExportOutlined,
  FilterOutlined,
  MoreOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import apiClient from "../../../Utils/apiClient"
import PanelLayout from "../../../Layout/PanelLayout"
import PageHeader from "../../../components/PageHeader/PageHeader"
import * as XLSX from "xlsx"
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"
import { saveAs } from "file-saver"
import AutoCompleteBox from "../../../components/AutoCompleteBox/AutoCompleteBox"
import TableBox from "../../../components/TableBox/TableBox"
import { useNotification } from "../../../components/Notification/Notification"
import { chocoUpgradeCommands, formatChocoActionCommand, uninstallCommand, wingetUpgradeCommand, wingetUpgradeCommands } from "../../../Utils/wingetPackage"
import { getStoredPageSize } from "../../../Utils/TableUtils/TableUtils"
import { useHeaderContext } from "../../../Utils/HeaderContext"
import { pendingAppUpdates } from "../../../Utils/updateCounts"
import { isUnixDevice } from "../../../Utils/deviceOs"

const AppManagement = ({ panel = true }) => {
  const { setRender, setTaskId } = useHeaderContext()
  const page = "Software Inventory"
  const [api, contextHolder] = notification.useNotification()
  const [filters, setFilters] = useState({
    appName: "",
    publisher: "",
    version: "",
    source: "",
  })
  const notify = useNotification()
  // const [isSynced, setIsSynced] = useState(false)
  const [loading, setLoading] = useState(true)
  const [isUpdating, setIsUpdating] = useState(false)
  const [isUninstalling, setIsUninstalling] = useState(false)
  const [isScanning, setIsScanning] = useState(false)
  // const [taskId, setTaskId] = useState(null)
  const [taskModalData, setTaskModalData] = useState(null)

  const [showMore, setShowMore] = useState(false)
  // const [isShowUpdateModal, setIsShowUpdateModal] = useState(false)
  const [device, setDevice] = useState({})
  const [updates, setUpdates] = useState([])
  const [filteredAppsData, setFilteredAppsData] = useState([])
  const [filteredUpdatesData, setFilteredUpdatesData] = useState([])
  const currentUrl = window.location.href
  const userId = currentUrl.split("/").pop()
  const navigate = useNavigate()
  const [view, setView] = useState("table") // "table" or "card"
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [paginationData, setPaginationData] = useState({
    page: 1,
    pageSize: getStoredPageSize(page) || 10,
    total: 0,
  })
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  // console.log(selectedRowKeys, "selctec row keys")
  const [activeTab, setActiveTab] = useState("app-updates")
  const handleClose = () => setIsShowUpdateModal(false)
  const { isShowUpdateModal, setIsShowUpdateModal } = useHeaderContext()

  const fetchDeviceData = async () => {
    setLoading(true)
    try {
      const data = await apiClient(`devices/${userId}`)
      if (data) {
        setDevice(data)
        setUpdates(pendingAppUpdates(data?.applicationUpdates))
      } else {
        console.error("Error fetching devices")
        setDevice({})
        setUpdates([])
      }
    } catch (err) {
      console.error("Error fetching devices:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDeviceData()
  }, [])

  useEffect(() => {
    if (device?._id && isUnixDevice(device)) {
      setActiveTab((prev) => (prev === "app-updates" ? "all-apps" : prev))
    }
  }, [device?._id])

  const compareVersions = (v1, v2) => {
    if (!v1 || !v2) return 0
    const splitV1 = String(v1).split(".").map(Number)
    const splitV2 = String(v2).split(".").map(Number)
    const maxLength = Math.max(splitV1.length, splitV2.length)

    for (let i = 0; i < maxLength; i++) {
      const num1 = splitV1[i] || 0
      const num2 = splitV2[i] || 0
      if (num1 > num2) return 1
      if (num1 < num2) return -1
    }
    return 0
  }
  const updatesTableData = updates.map((update, index) => ({
    key: `${update.appName}-${update.currentVersion}`,
    name: String(update.name || update.appName || ""),
    appName: String(update.appName || update.name || ""),
    publisher: String(update.publisher || "Unknown"),
    version: String(update.currentVersion || ""),
    availableVersion: update.availableVersion,
    updateAvailable: true,
    source: update.source,
  }))
  const selectedApps = updatesTableData.filter((app) =>
    selectedRowKeys.includes(app.key)
  )

  const handleUpdateApp = async () => {
    console.log("appManagement js Update App handleUpdateApp")

    const wingetApps = selectedApps.filter((app) => app.source === "winget")
    const chocoApps = selectedApps.filter((app) => app.source === "choco")
    const commands = []
    const apps = []

    if (wingetApps.length > 0) {
      const commandsForWinget = wingetUpgradeCommands(wingetApps)
      if (!commandsForWinget.length) {
        message.warning("Could not resolve Winget package IDs for the selected apps")
      } else {
        commands.push(
          ...commandsForWinget.map((command) => ({
            name: command.replace("winget-upgrade:", ""),
            command,
            source: "winget",
          }))
        )
      }
    }

    if (chocoApps.length > 0) {
      commands.push(
        ...chocoUpgradeCommands(chocoApps).map((command) => ({
          name: command.replace("choco-upgrade:", ""),
          command,
          source: "choco",
        }))
      )
    }

    setIsUpdating(true)
    const hostname = device?.hostname

    for (const cmd of commands) {
      const payload = {
        entityType: `upgrade${cmd.source}`,
        hostname,
        name: cmd.name,
        command: cmd.command,
        appData: cmd.source === "choco" ? chocoApps : wingetApps,
      }

      try {
        message.info(`task created for ${hostname}`)
        const response = await apiClient(
          `devices/${hostname}/create-task`,
          "POST",
          payload
        )
        message.success(`Created Task For ${hostname}`)
        if (response) {
          setTaskId(response.taskId)
          setRender((pre) => !pre)
        }
      } catch (err) {
        console.error("Error sending update task:", err)
        notify({
          title: "Update Failed",
          type: "error",
          description: `Failed to queue updates: ${err.message}`,
        })
      }
    }

    setIsUpdating(false)
  }

  const handleScanApps = async () => {
    if (!device?.hostname) return
    setIsScanning(true)
    try {
      await apiClient(`devices/${device.hostname}/create-task`, "POST", {
        entityType: "check-updates",
        hostname: device.hostname,
        name: "check-updates",
        command: "check-updates",
      })
      message.success(
        isUnixDevice(device)
          ? `Queued an app scan for ${device.hostname}`
          : `Queued an app and Windows update scan for ${device.hostname}`
      )
      setRender((pre) => !pre)
    } catch (err) {
      message.error(err.message || "Failed to queue the app scan")
    } finally {
      setIsScanning(false)
    }
  }

  const handleUpdateAllApps = async () => {
    if (!device?.hostname) return
    if (!updates.length) {
      message.info("No pending app updates to install")
      return
    }
    setIsUpdating(true)
    try {
      const res = await apiClient("devices/update-all-apps", "POST", {
        hostname: device.hostname,
        applicationUpdates: updates,
      })
      if (res?.success === false) {
        message.error(res.message || "Failed to queue app updates")
      } else {
        message.success(
          res.message || `Queued ${updates.length} app update(s) for ${device.hostname}`
        )
        setRender((pre) => !pre)
      }
    } catch (err) {
      message.error(err.message || "Failed to queue app updates")
    } finally {
      setIsUpdating(false)
    }
  }

  const updateApp = async (hostname, app) => {
    setIsUpdating(true)
    message.info(`Updating ${app.name} ...`)

    console.log("AppManagement.js updateApp function")

    const name = app.name
    const appName = app.appName
    let command = formatChocoActionCommand("upgrade", appName)
    if (app.source === "winget") {
      command = wingetUpgradeCommand(app)
      if (!command) {
        message.warning("Could not resolve the Winget package ID for this app")
        setIsUpdating(false)
        return
      }
    }
    const payload = {
      entityType: `upgrade${app.source}`,
      hostname,
      name: name,
      command: command,
      appData: [app],
    }

    try {
      message.info(`task created for ${hostname}`)
      const response = await apiClient(
        `devices/${hostname}/create-task`,
        "POST",
        payload
      )
      message.success(`Created Task For ${hostname} ...`)

      if (response?.taskId) {
        setTaskId(response.taskId)
        setRender((pre) => !pre)
      }
      if (response?.status === "Blocked") {
        message.warning(response.message || "Update blocked")
      }
    } catch (err) {
      console.error("Error sending update tasks:", err)
      message.error("Failed to queue the Winget upgrade")
    } finally {
      setIsUpdating(false)
    }
  }

  const commandForUninstall = (app) => {
    const label = String(app?.name || app?.appName || "").trim()
    if (!label) return null
    if (app.source === "winget" || app.source === "choco") {
      return uninstallCommand(app) || `app-uninstall:${label}`
    }
    return `app-uninstall:${label}`
  }

  const enqueueUninstall = async (apps) => {
    const hostname = device?.hostname
    const list = (Array.isArray(apps) ? apps : [apps]).filter(Boolean)
    if (!hostname || !list.length) return 0
    let queued = 0
    let lastTaskId = null
    for (const app of list) {
      const command = commandForUninstall(app)
      const label = String(app?.name || app?.appName || command).trim()
      if (!command) continue
      try {
        const response = await apiClient(
          `devices/${hostname}/create-task`,
          "POST",
          {
            entityType: "uninstallapp",
            hostname,
            name: label,
            command,
            appData: [app],
          }
        )
        queued += 1
        if (response?.taskId) lastTaskId = response.taskId
      } catch (err) {
        message.error(
          err.message || `Could not queue uninstall for ${label}`
        )
      }
    }
    if (lastTaskId) {
      setTaskId(lastTaskId)
      setRender((pre) => !pre)
    }
    setSelectedRowKeys([])
    if (!queued) return 0
    message.success(
      queued === 1
        ? `Uninstall queued on ${hostname}`
        : `Queued uninstall of ${queued} apps on ${hostname}`
    )
    return queued
  }

  const queueAppControl = (apps, action) => {
    const hostname = device?.hostname
    const list = (Array.isArray(apps) ? apps : [apps]).filter(Boolean)
    if (!hostname || !list.length) return
    const verb = action === "allow" ? "Allow" : "Block"
    Modal.confirm({
      title: `${verb} ${
        list.length === 1
          ? list[0]?.name || list[0]?.appName || "this app"
          : `${list.length} apps`
      } on ${hostname}?`,
      content:
        action === "allow"
          ? "The agent will stop blocking these processes. Needs agent 1.63."
          : "The agent will close matching processes and keep them closed. Needs agent 1.63. System processes cannot be blocked.",
      okText: verb,
      okButtonProps: action === "block" ? { danger: true } : undefined,
      onOk: async () => {
        let queued = 0
        let lastTaskId = null
        for (const app of list) {
          const label = String(app?.name || app?.appName || "").trim()
          if (!label) continue
          try {
            const response = await apiClient(
              `devices/${hostname}/app-control`,
              "POST",
              {
                action,
                appName: label,
                name: label,
                packageId: app.packageId || app.id || "",
              }
            )
            if (!response?.success) {
              message.error(response?.message || `Could not ${action} ${label}`)
              continue
            }
            queued += 1
            if (response?.taskId) lastTaskId = response.taskId
            if (response?.result) {
              setDevice((prev) => ({
                ...prev,
                blockedApps: response.result.blockedApps || prev.blockedApps,
                allowedApps: response.result.allowedApps || prev.allowedApps,
              }))
            }
          } catch (err) {
            message.error(err.message || `Could not ${action} ${label}`)
          }
        }
        if (lastTaskId) {
          setTaskId(lastTaskId)
          setRender((pre) => !pre)
        }
        if (queued) {
          message.success(
            queued === 1
              ? `${verb} queued on ${hostname}`
              : `Queued ${action} of ${queued} apps on ${hostname}`
          )
        }
        setSelectedRowKeys([])
      },
    })
  }

  const selectedAppRows = () =>
    (activeTab === "all-apps" ? filteredAppsData : updatesTableData).filter(
      (row) => selectedRowKeys.includes(row.key)
    )

  const queueUninstall = (app) => {
    const hostname = device?.hostname
    const label = app?.name || app?.appName || "this app"
    if (!hostname || !label || label === "this app") return
    Modal.confirm({
      title: `Uninstall ${label}?`,
      content: `This removes the app from ${hostname}. The PC may need a restart.`,
      okText: "Uninstall",
      okButtonProps: { danger: true },
      onOk: () => enqueueUninstall([app]),
    })
  }

  const queueUninstallSelected = () => {
    const rows = (
      activeTab === "all-apps" ? filteredAppsData : updatesTableData
    ).filter((row) => selectedRowKeys.includes(row.key))
    const hostname = device?.hostname
    if (!hostname || !rows.length) return
    Modal.confirm({
      title: `Uninstall ${rows.length} apps?`,
      content: (
        <div>
          <p>
            This removes {rows.length} apps from {hostname}. The PC may need a
            restart.
          </p>
          <ul style={{ maxHeight: 180, overflow: "auto", paddingLeft: 18 }}>
            {rows.slice(0, 12).map((row) => (
              <li key={row.key}>{row.name || row.appName}</li>
            ))}
            {rows.length > 12 ? <li>and {rows.length - 12} more</li> : null}
          </ul>
        </div>
      ),
      okText: "Uninstall",
      okButtonProps: { danger: true },
      onOk: async () => {
        setIsUninstalling(true)
        try {
          await enqueueUninstall(rows)
        } catch (err) {
          message.error(err.message || "Could not queue uninstall")
        } finally {
          setIsUninstalling(false)
        }
      },
    })
  }

  const TableView = ({ dataSource, loading, isUpdatesTab = false }) => {
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width:450,
        render: (value, record) =>
          String(value || record?.appName || record?.name || "—"),
      },
      ...(!isUpdatesTab
        ? [
            {
              title: "Publisher",
              dataIndex: "publisher",
              key: "publisher",
              render: (value) => String(value || "—"),
            },
          ]
        : []),
      {
        title: "Current Version",
        dataIndex: "version",
        key: "version",
        render: (value) => String(value || "—"),
      },
      ...(!isUpdatesTab
        ? [
            {
              title: "Source",
              dataIndex: "source",
              key: "source",
            },
          ]
        : []),
      ...(isUpdatesTab
        ? [
            {
              title: "Available Version",
              dataIndex: "availableVersion",
              key: "availableVersion",
            },
          ]
        : []),

      ...(isUpdatesTab
        ? [
            {
              title: "Source",
              dataIndex: "source",
              key: "source",
            },
          ]
        : []),

      ...((!isUpdatesTab || selectedRowKeys.length === 0)
        ? [
            {
              title: "Action",
              key: "action",
              width: 90,
              render: (_, record) => (
                <Dropdown
                  overlay={
                    <Menu>
                      {isUpdatesTab ? (
                        <Menu.Item
                          key="update"
                          onClick={() => updateApp(device.hostname, record)}
                        >
                          <CloudUploadOutlined />{" "}
                          {isUpdating ? "Updating ..." : "Update"}
                        </Menu.Item>
                      ) : null}
                      <Menu.Item
                        key="block"
                        onClick={() => queueAppControl(record, "block")}
                      >
                        Block
                      </Menu.Item>
                      <Menu.Item
                        key="allow"
                        onClick={() => queueAppControl(record, "allow")}
                      >
                        Allow
                      </Menu.Item>
                      <Menu.Item
                        key="uninstall"
                        onClick={() => queueUninstall(record)}
                      >
                        Uninstall
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                >
                  <Button size="small" icon={<MoreOutlined />} />
                </Dropdown>
              ),
            },
          ]
        : []),
    ]

    const rowSelection = {
      selectedRowKeys,
      onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
    }

    return (
      <TableBox
        data={dataSource}
        columns={columns}
        loading={loading}
        page={page}
        rowSelection={rowSelection}
        pagination={{
          total: paginationData.total,
          current: paginationData.page,
          pageSize: paginationData.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20", "50"],
          onChange: (page, pageSize) => {
            setPaginationData((prev) => ({ ...prev, page, pageSize }))
          },
        }}
      />
    )
  }

  const GridView = ({ dataSource, isUpdatesTab = false }) => {
    const labelOf = (app) =>
      String(app?.name || app?.appName || "").trim() || "—"
    return (
      <Row gutter={[16, 16]}>
        {dataSource.map((app, i) => (
          <Col key={i} xs={24} sm={24} md={12} lg={8}>
            <Card
              title={
                isUpdatesTab
                  ? `Available Update: ${app.availableVersion || "N/A"}`
                  : labelOf(app)
              }
              extra={
                <Space wrap>
                  {isUpdatesTab && app.updateAvailable ? (
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => updateApp(device.hostname, app)}
                    >
                      Update
                    </Button>
                  ) : null}
                  <Button
                    size="small"
                    danger
                    onClick={() => queueAppControl(app, "block")}
                  >
                    Block
                  </Button>
                  <Button size="small" onClick={() => queueAppControl(app, "allow")}>
                    Allow
                  </Button>
                  <Button size="small" danger onClick={() => queueUninstall(app)}>
                    Uninstall
                  </Button>
                </Space>
              }
            >
              <p>
                <strong>Name:</strong> {labelOf(app)}
              </p>
              <p>
                <strong>Publisher:</strong> {String(app.publisher || "—")}
              </p>
              <p>
                <strong>Version:</strong> {String(app.version || "—")}
              </p>
            </Card>
          </Col>
        ))}
      </Row>
    )
  }

  const appsTableData = (device?.apps || []).map((app, index) => {
    const matchedUpdate = updates.find(
      (update) =>
        update?.name &&
        app?.name &&
        update.name.toLowerCase().includes(String(app.name).toLowerCase())
    )
    const isUpdateAvailable =
      matchedUpdate &&
      compareVersions(matchedUpdate.availableVersion, app.version) > 0

    return {
      key: `${app.name || "app"}::${app.version || ""}::${app.publisher || ""}::${index}`,
      name: String(app.name || app.appName || ""),
      publisher: String(app.publisher || app.source || "—"),
      version: String(app.version || "—"),
      availableVersion: matchedUpdate?.availableVersion || null,
      isUpdateAvailable,
      updateData: matchedUpdate,
      source: String(app.source || ""),
    }
  })

  useEffect(() => {
    setFilteredAppsData(appsTableData)
    setFilteredUpdatesData(updatesTableData)
    setPaginationData((prev) => ({
      ...prev,
      total:
        activeTab === "all-apps"
          ? appsTableData.length
          : updatesTableData.length,
      page: 1,
    }))
  }, [device, updates, activeTab])

  const handleFilter = async () => {
    try {
      const res = await apiClient(
        `filter/applications/${device._id}`,
        "POST",
        filters
      )
      if (res?.success && Array.isArray(res?.result)) {
        const updatedAppsData = res.result.map((app, index) => {
          const matchedUpdate = updates.find((update) =>
            update.name.toLowerCase().includes(app.name.toLowerCase())
          )
          const isUpdateAvailable =
            matchedUpdate &&
            compareVersions(matchedUpdate.availableVersion, app.version) > 0

          return {
            key: `${app.name || "app"}::${app.version || ""}::${app.publisher || ""}::${index}`,
            name: app.name,
            appName: app.appName,
            publisher: app.publisher,
            version: app.version,
            availableVersion: matchedUpdate?.availableVersion || null,
            updateAvailable: app.updateAvailable || isUpdateAvailable,
          }
        })
        const filteredUpdates = updatesTableData.filter(
          (update) =>
            (!filters.appName ||
              update.name
                .toLowerCase()
                .includes(filters.appName.toLowerCase())) &&
            (!filters.publisher ||
              (update.publisher || "")
                .toLowerCase()
                .includes(filters.publisher.toLowerCase())) &&
            (!filters.version ||
              update.version
                .toLowerCase()
                .includes(filters.version.toLowerCase())) &&
            (!filters.source ||
              update.source
                .toLowerCase()
                .includes(filters.source.toLowerCase()))
        )
        setFilteredAppsData(updatedAppsData)
        setFilteredUpdatesData(filteredUpdates)
        setPaginationData((prev) => ({
          ...prev,
          total:
            activeTab === "all-apps"
              ? updatedAppsData.length
              : filteredUpdates.length,
          page: 1,
        }))
        setDrawerOpen(false)
      }
    } catch (err) {
      console.error("Filter failed", err)
      notify({
        title: "Filter Error",
        type: "error",
        description: "Failed to apply filters.",
      })
    }
  }

  const handleClearFilter = () => {
    setFilters({
      appName: "",
      publisher: "",
      version: "",
      source: "",
    })
    setFilteredAppsData(appsTableData)
    setFilteredUpdatesData(updatesTableData)
    setPaginationData((prev) => ({
      ...prev,
      total:
        activeTab === "all-apps"
          ? appsTableData.length
          : updatesTableData.length,
      page: 1,
    }))
    setDrawerOpen(false)
  }

  const exportToPDF = (data, filename) => {
    const doc = new jsPDF()
    const tableColumn = ["Name", "Publisher", "Version", "Available Update"]
    const tableRows = data.map((item) => [
      item.name,
      item.publisher,
      item.version,
      item.availableVersion || "N/A",
    ])
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
    })
    doc.save(filename)
  }

  const exportToExcel = (data, filename) => {
    const worksheetData = data.map((item) => ({
      Name: item.name,
      Publisher: item.publisher,
      Version: item.version,
      "Available Update": item.availableVersion || "N/A",
    }))
    const worksheet = XLSX.utils.json_to_sheet(worksheetData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "App_Management")
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    })
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" })
    saveAs(blob, filename)
  }

  const tabExtraContent = (
    <div className="d-flex flex-column justify-content-between">
      <div className="mb-2 d-flex justify-content-end align-items-center">
        <Space>
          <Tooltip title="Table View">
            <Button
              icon={<UnorderedListOutlined />}
              type={view === "table" ? "primary" : "default"}
              onClick={() => setView("table")}
              size="small"
            />
          </Tooltip>
          <Tooltip title="Card View">
            <Button
              icon={<AppstoreOutlined />}
              type={view === "card" ? "primary" : "default"}
              onClick={() => setView("card")}
              size="small"
            />
          </Tooltip>
        </Space>
        <Divider
          type="vertical"
          style={{ height: 32, backgroundColor: "#2563eb" }}
        />
        <div className="d-flex align-items-center">
          <Button
            onClick={() => setDrawerOpen(true)}
            className="me-2 position-relative"
            size="small"
          >
            <FilterOutlined />
          </Button>
          <Drawer
            title={
              <div className="d-flex justify-content-between align-items-center w-100">
                <span>Apply Filter</span>
                <CloseOutlined
                  onClick={() => setDrawerOpen(false)}
                  className="rounded-circle p-1"
                  style={{
                    color: "rgba(0,0,0,0.6)",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
            mask={false}
            placement="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            closable={false}
            width={300}
          >
            <div className="d-flex flex-column justify-content-between h-100">
              <div className="p-3">
                <AutoCompleteBox
                  label="App Name"
                  name="appName"
                  className="mb-3 w-100"
                  endPoint={`applications/${device._id}`}
                  placeholder="Search App Name"
                  value={filters.appName}
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, appName: value }))
                  }
                />
                <AutoCompleteBox
                  label="Publisher"
                  name="publisher"
                  className="mb-3 w-100"
                  endPoint={`applications/${device._id}`}
                  placeholder="Search Publisher"
                  value={filters.publisher}
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, publisher: value }))
                  }
                />
                <AutoCompleteBox
                  label="Version"
                  name="version"
                  className="mb-3 w-100"
                  endPoint={`applications/${device._id}`}
                  placeholder="Search Version"
                  value={filters.version}
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, version: value }))
                  }
                />

                {activeTab !== "all-apps" && (
                  <div className="mb-3 w-100">
                    <label
                      style={{
                        fontWeight: 500,
                        marginBottom: 4,
                        display: "block",
                      }}
                    >
                      Source
                    </label>
                    <Select
                      placeholder="Select device status"
                      value={filters.source || undefined}
                      onChange={(value) =>
                        setFilters((prev) => ({ ...prev, source: value }))
                      }
                      allowClear
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="choco">Choco</Select.Option>
                      <Select.Option value="winget">Winget</Select.Option>
                    </Select>
                  </div>
                )}
              </div>
              <div className="p-3 d-flex gap-2">
                <Button
                  size="small"
                  className="btn-form-filter rounded-pill"
                  onClick={handleFilter}
                >
                  Apply Filter
                </Button>
                <Button
                  size="small"
                  className="btn-form-filter rounded-pill"
                  onClick={handleClearFilter}
                >
                  Clear Filter
                </Button>
              </div>
            </div>
          </Drawer>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="pdf"
                  onClick={() =>
                    exportToPDF(
                      activeTab === "all-apps"
                        ? filteredAppsData
                        : filteredUpdatesData,
                      activeTab === "all-apps"
                        ? "All_Apps.pdf"
                        : "App_Updates.pdf"
                    )
                  }
                >
                  Export as PDF
                </Menu.Item>
                <Menu.Item
                  key="excel"
                  onClick={() =>
                    exportToExcel(
                      activeTab === "all-apps"
                        ? filteredAppsData
                        : filteredUpdatesData,
                      activeTab === "all-apps"
                        ? "All_Apps.xlsx"
                        : "App_Updates.xlsx"
                    )
                  }
                >
                  Export as Excel
                </Menu.Item>
              </Menu>
            }
            placement="bottomRight"
            arrow
          >
            <Button size="small" icon={<ExportOutlined />}>
              Export
            </Button>
          </Dropdown>
          {activeTab === "app-updates" && (
            <>
              {!isUnixDevice(device) ? (
                <Button
                  size="small"
                  className="ms-2"
                  icon={<CloudSyncOutlined />}
                  loading={isScanning}
                  onClick={handleScanApps}
                  disabled={!device?.hostname}
                >
                  Scan apps
                </Button>
              ) : null}
              <Button
                size="small"
                className="ms-2"
                type="primary"
                icon={<CloudUploadOutlined />}
                loading={isUpdating}
                onClick={handleUpdateAllApps}
                disabled={!device?.hostname || updates.length === 0}
              >
                Update all apps
              </Button>
            </>
          )}
          {selectedRowKeys?.length > 0 && activeTab === "app-updates" && (
            <Button
              size="small"
              icon={<CloudUploadOutlined />}
              type="primary"
              className="ms-2"
              onClick={handleUpdateApp}
            >
              Update {selectedRowKeys.length}
            </Button>
          )}
          {selectedRowKeys?.length > 0 && (
            <>
              <Button
                size="small"
                danger
                className="ms-2"
                onClick={() => queueAppControl(selectedAppRows(), "block")}
              >
                Block {selectedRowKeys.length}
              </Button>
              <Button
                size="small"
                className="ms-2"
                onClick={() => queueAppControl(selectedAppRows(), "allow")}
              >
                Allow {selectedRowKeys.length}
              </Button>
              <Button
                size="small"
                danger
                icon={<DeleteOutlined />}
                className="ms-2"
                loading={isUninstalling}
                onClick={queueUninstallSelected}
              >
                Uninstall {selectedRowKeys.length}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  )

  const controlLabel = (value) => {
    if (value == null) return ""
    if (typeof value === "object") {
      return String(
        value.appName || value.name || value.processName || value.id || ""
      ).trim()
    }
    return String(value).trim()
  }
  const blockedApps = (Array.isArray(device?.blockedApps) ? device.blockedApps : [])
    .map(controlLabel)
    .filter(Boolean)
  const allowedApps = (Array.isArray(device?.allowedApps) ? device.allowedApps : [])
    .map(controlLabel)
    .filter(Boolean)
  const blockedUrls = (Array.isArray(device?.blockedUrls) ? device.blockedUrls : [])
    .map(controlLabel)
    .filter(Boolean)
  const allowedUrls = (Array.isArray(device?.allowedUrls) ? device.allowedUrls : [])
    .map(controlLabel)
    .filter(Boolean)
  const hasControl =
    blockedApps.length ||
    allowedApps.length ||
    blockedUrls.length ||
    allowedUrls.length

  const content = (
    <>
      {hasControl ? (
        <div className="mb-3">
          {blockedApps.length ? (
            <div className="mb-2">
              <span className="app-mgmt__muted me-2">Blocked apps</span>
              {blockedApps.map((name) => (
                <Tag key={`block-${name}`} color="red">
                  {name}
                </Tag>
              ))}
            </div>
          ) : null}
          {allowedApps.length ? (
            <div className="mb-2">
              <span className="app-mgmt__muted me-2">Allowed apps</span>
              {allowedApps.map((name) => (
                <Tag key={`allow-${name}`} color="green">
                  {name}
                </Tag>
              ))}
            </div>
          ) : null}
          {blockedUrls.length ? (
            <div className="mb-2">
              <span className="app-mgmt__muted me-2">Blocked websites</span>
              {blockedUrls.map((name) => (
                <Tag key={`block-url-${name}`} color="red">
                  {name}
                </Tag>
              ))}
            </div>
          ) : null}
          {allowedUrls.length ? (
            <div className="mb-2">
              <span className="app-mgmt__muted me-2">Website exemptions</span>
              {allowedUrls.map((name) => (
                <Tag key={`allow-url-${name}`} color="green">
                  {name}
                </Tag>
              ))}
            </div>
          ) : null}
          <Button type="link" className="p-0" onClick={() => navigate("/app-control")}>
            Manage on App control
          </Button>
        </div>
      ) : null}
    <Tabs
      activeKey={activeTab}
      onChange={(key) => {
        setActiveTab(key)
        setSelectedRowKeys([])
      }}
      tabBarExtraContent={tabExtraContent}
      items={[
        {
          key: "app-updates",
          label: "Available App Updates",
          children: loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: 200 }}
            >
              <Spin tip="Loading..." />
            </div>
          ) : filteredUpdatesData.length > 0 ? (
            view === "table" ? (
              <TableView
                dataSource={filteredUpdatesData}
                loading={loading}
                isUpdatesTab={true}
              />
            ) : (
              <GridView dataSource={filteredUpdatesData} isUpdatesTab={true} />
            )
          ) : (
            <Card>
              <Empty description="Software is up to date" />
            </Card>
          ),
        },
        {
          key: "all-apps",
          label: "All Apps",
          children: loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: 200 }}
            >
              <Spin tip="Loading..." />
            </div>
          ) : filteredAppsData.length > 0 ? (
            view === "table" ? (
              <TableView dataSource={filteredAppsData} loading={loading} />
            ) : (
              <GridView dataSource={filteredAppsData} />
            )
          ) : (
            <p>No Applications Found</p>
          ),
        },
      ]}
    />
    </>
  )

  return panel ? (
    <PanelLayout
      title="App Management"
      subtitle="Installed applications and pending software updates for this device."
    >
      {content}
    </PanelLayout>
  ) : (
    <div className="device-tab-panel">
      <PageHeader
        title="Software"
        subtitle="Review installed apps and queue software updates on this endpoint."
      />
      {content}
    </div>
  )
}

export default AppManagement
